import Native from '../../../controllers/native';

export default class NativePlacement {

  /**
   * Injects native ad slots into the desired locations across the cluster
   *
   * Currently the following sites are serviced -
   *
   * Courier
   * Energy Voice
   * Press & Journal
   * Sunday Post
   * Evening Express
   *
   * @param pageData          - Page level targeting data
   * @returns {Promise<void>}
   */
  static async setupSlots( pageData ) {

    let insertPosition = 2;

    // In-article native slot placement overrides
    if ( ( pageData.post_type === 'post' || pageData.post_type === 'fp' ) && pageData.is_article === 'yes' ) {

      // Check for a v1 register wall (different markup to other UICs) and don't place the native ad slot if found
      let registerWall = document.querySelector( 'article .cms > section.blaize-meter' );

      if ( registerWall ) {
        console.log( 'Register Wall detected, native slot not placed' );
        return;
      }

      // For v1 first position UICs they are the second element in the article container, following the UICs style tag, if one is found insert the native ad slot at position 4.
      let uicv1 = document.querySelector( 'article .cms > :nth-child(2)' );

      if (typeof(uicv1) != 'undefined' && uicv1 != null && uicv1.classList.contains( 'dct-cta-wrap' ) ) {
        console.log( 'In article UIC detected in position 1, native slot insert position amended' );
        insertPosition = 4;
      }

	    // V2 first position UICs are always the first element in the article container, if one is found insert the native ad slot at position 3.
      let uicv2 = document.querySelector( 'article .cms > :first-child' );

      if (typeof(uicv2) != 'undefined' && uicv2 != null && uicv2.hasAttribute( 'data-uic' ) ) {
        console.log( 'In article UIC detected in position 1, native slot insert position amended' );
        insertPosition = 3;
      }

    }

    // Courier Homepage placement
    if ( pageData.hostname.includes( 'thecourier' ) && (pageData.is_home === 'true') ) {
      await Native.placeSlot(
        'courier-home-news-block-native-slot',
        'section.block--news.block--grid .content article.post:nth-child(3)',
        'post post--grid category-color--news native-ad-slot native-ad-slot--home',
        'article',
        true
      );
    }

    // Courier Archive placement
    if ( pageData.hostname.includes( 'thecourier' ) && pageData.is_category === 'true' ) {
      await Native.placeSlot(
        'courier-category-news-block-native-slot',
        'section.block--news.block--grid .content article.post:nth-child(3)',
        'post post--grid category-color--news native-ad-slot native-ad-slot--category',
        'article',
        true
      );
    }

    // Courier Article placement
    if ( pageData.hostname.includes( 'thecourier' ) && (pageData.post_type === 'post' || pageData.post_type === 'fp') && pageData.is_article === 'yes' ) {
      await Native.placeSlot(
        'courier-article-native-slot',
        'article .cms > :last-child',
        'native-ad-slot native-ad-slot--article',
        'p',
        false
      );
    }

    // EV Homepage placement
    if ( pageData.hostname.includes( 'energyvoice' ) && pageData.is_home === 'true' ) {
      await Native.placeSlot(
        'ev-home-top-story-with-sections-sidebar-native-slot',
        'section.block--top-story-with-sections .block--top-story__grid-aside.promoted .post:first-child',
        'post post--promoted native-ad-slot native-ad-slot--home',
        'article',
        true
      );
      await Native.placeSlot(
        'ev-blocks-vertical-list-native-slot',
        '.native-ad-list > li:first-child',
        'gb-article-list-block',
        'li',
        true
      );
    }

    // EV Category placements
    if ( pageData.hostname.includes( 'energyvoice' ) && pageData.is_category === 'true' ) {

      let premiumSlotPlaced = await Native.placeSlot(
        'ev-category-premium-block-sidebar-native-slot',
        'section.block--premium .block--premium__grid-aside .post:last-child',
        'post post__premium--default native-ad-slot native-ad-slot--category',
        'article',
        true
      );

      if ( ! premiumSlotPlaced ) {
        premiumSlotPlaced = await Native.placeSlotInContainer( 
          'ev-category-premium-block-sidebar-native-slot', 
          'section.block--premium .block--premium__grid-aside', 
          'post post__premium--default native-ad-slot native-ad-slot--category', 
          'article' 
        );
      }

      if ( ! premiumSlotPlaced ) {
        await Native.placeSlot(
          'ev-category-post-list-native-slot',
          'section.block--papertray .content article.post:nth-child(2)',
          'post native-ad-slot native-ad-slot--category',
          'article',
          false
        );
      }

      if ( ! premiumSlotPlaced ) {
        await Native.placeSlot(
          'ev-category-post-list-native-slot',
          'section.wrap .content article.post:nth-child(2)',
          'post native-ad-slot native-ad-slot--category',
          'article',
          false
        );
      }

    }

    // EV Article placement
    if ( pageData.hostname.includes( 'energyvoice' ) && (pageData.post_type === 'post' || pageData.post_type === 'fp') && pageData.is_article === 'yes' ) {
      await Native.placeSlot(
        'ev-article-native-slot',
        `article .cms > :nth-child( ${ insertPosition } )`,
        'native-ad-slot native-ad-slot--article',
        'p',
        false
      );
    }

    // P&J Homepage placement
    if ( pageData.hostname.includes( 'pressandjournal' ) && pageData.is_home === 'true' ) {

      await Native.placeSlot(
        'pressandjournal-home-premium-block-sidebar-native-slot',
        'section.block--premium .block--premium__grid-aside .post:nth-child(3)',
        'post post__premium--default native-ad-slot native-ad-slot--home',
        'article',
        true
      );
    }

    // P&J Category placement
    if ( pageData.hostname.includes( 'pressandjournal' ) && pageData.is_category === 'true' ) {
      await Native.placeSlot(
        'pressandjournal-category-premium-block-sidebar-native-slot',
        'section.block--premium .block--premium__grid-aside .post:nth-child(2)',
        'post post__premium--default native-ad-slot native-ad-slot--category',
        'article',
        true
      );
    }

    // P&J Article placement
    if ( pageData.hostname.includes( 'pressandjournal' ) && (pageData.post_type === 'post' || pageData.post_type === 'fp') && pageData.is_article === 'yes' ) {
      await Native.placeSlot(
        'pressandjournal-article-native-slot',
        'article .cms > :last-child',
        'native-ad-slot native-ad-slot--article',
        'p',
        false
      );
    }

    // Sunday Post Homepage placement
    if ( pageData.hostname.includes( 'sundaypost' ) && pageData.is_home === 'true' ) {

      await Native.placeSlot(
        'sundaypost-home-premium-block-sidebar-native-slot',
        'section.block--premium .block--premium__grid-aside .post:nth-child(2)',
        'post post__premium--default native-ad-slot native-ad-slot--home',
        'article',
        true
      );
    }

    // Sunday Post Archive placement
    if ( pageData.hostname.includes( 'sundaypost' ) && pageData.is_category === 'true' ) {
      await Native.placeSlot(
        'sundaypost-category-news-block-native-slot',
        'section.block--news.block--grid .content article.post:nth-child(3)',
        'post post--grid category-color--news native-ad-slot native-ad-slot--category',
        'article',
        true
      );
    }

    // Sunday Post Article placement
    if ( pageData.hostname.includes( 'sundaypost' ) && (pageData.post_type === 'post' || pageData.post_type === 'fp') && pageData.is_article === 'yes' ) {
      await Native.placeSlot(
        'sundaypost-article-native-slot',
        `article .cms > :nth-child( ${ insertPosition } )`,
        'native-ad-slot native-ad-slot--article',
        'p',
        false
      );
    }

  }

}